export default {
	"total": [{
		"value": "148971",
		"name": "北京"
	}, {
		"value": "737625",
		"name": "天津"
	}, {
		"value": "2013690",
		"name": "河北"
	}, {
		"value": "1183651",
		"name": "山西"
	}, {
		"value": "2238847",
		"name": "河南"
	}, {
		"value": "2653458",
		"name": "山东"
	}, {
		"value": "315170",
		"name": "上海"
	}, {
		"value": "2470900",
		"name": "江苏"
	}, {
		"value": "2667009",
		"name": "浙江"
	}, {
		"value": "319582",
		"name": "福建"
	}, {
		"value": "1789013",
		"name": "安徽"
	}, {
		"value": "1490822",
		"name": "江西"
	}, {
		"value": "1980094",
		"name": "湖北"
	}, {
		"value": "2149568",
		"name": "湖南"
	}, {
		"value": "3005852",
		"name": "广东"
	}, {
		"value": "795497",
		"name": "广西"
	}, {
		"value": "679995",
		"name": "贵州"
	}, {
		"value": "826231",
		"name": "云南"
	}, {
		"value": "118793",
		"name": "海南"
	}, {
		"value": "101900",
		"name": "黑龙江"
	}, {
		"value": "261351",
		"name": "吉林"
	}, {
		"value": "472903",
		"name": "辽宁"
	}, {
		"value": "983869",
		"name": "陕西"
	}, {
		"value": "280348",
		"name": "新疆"
	}, {
		"value": "584533",
		"name": "内蒙古"
	}, {
		"value": "286354",
		"name": "青海"
	}, {
		"value": "194162",
		"name": "宁夏"
	}, {
		"value": "108399",
		"name": "甘肃"
	}, {
		"value": "2759",
		"name": "西藏"
	}, {
		"value": "370853",
		"name": "四川"
	}, {
		"value": "446061",
		"name": "重庆"
	}],
	"list": [{
		"item": [{
			"value": "-1",
			"name": "北京"
		}, {
			"value": "158108",
			"name": "天津"
		}, {
			"value": "234154",
			"name": "河北"
		}, {
			"value": "15736",
			"name": "山西"
		}, {
			"value": "44414",
			"name": "河南"
		}, {
			"value": "59319",
			"name": "山东"
		}, {
			"value": "3535",
			"name": "上海"
		}, {
			"value": "32125",
			"name": "江苏"
		}, {
			"value": "10988",
			"name": "浙江"
		}, {
			"value": "2113",
			"name": "福建"
		}, {
			"value": "12128",
			"name": "安徽"
		}, {
			"value": "8401",
			"name": "江西"
		}, {
			"value": "22659",
			"name": "湖北"
		}, {
			"value": "15572",
			"name": "湖南"
		}, {
			"value": "15592",
			"name": "广东"
		}, {
			"value": "3176",
			"name": "广西"
		}, {
			"value": "1767",
			"name": "贵州"
		}, {
			"value": "1725",
			"name": "云南"
		}, {
			"value": "362",
			"name": "海南"
		}, {
			"value": "2428",
			"name": "黑龙江"
		}, {
			"value": "3383",
			"name": "吉林"
		}, {
			"value": "18202",
			"name": "辽宁"
		}, {
			"value": "6493",
			"name": "陕西"
		}, {
			"value": "717",
			"name": "新疆"
		}, {
			"value": "15413",
			"name": "内蒙古"
		}, {
			"value": "389",
			"name": "青海"
		}, {
			"value": "1021",
			"name": "宁夏"
		}, {
			"value": "487",
			"name": "甘肃"
		}, {
			"value": "3",
			"name": "西藏"
		}, {
			"value": "3035",
			"name": "四川"
		}, {
			"value": "3212",
			"name": "重庆"
		}],
		"nameName": "北京",
		"toatl": "696657"
	}, {
		"item": [{
			"value": "14592",
			"name": "北京"
		}, {
			"value": "-1",
			"name": "天津"
		}, {
			"value": "140148",
			"name": "河北"
		}, {
			"value": "14935",
			"name": "山西"
		}, {
			"value": "29620",
			"name": "河南"
		}, {
			"value": "54131",
			"name": "山东"
		}, {
			"value": "1908",
			"name": "上海"
		}, {
			"value": "30951",
			"name": "江苏"
		}, {
			"value": "7860",
			"name": "浙江"
		}, {
			"value": "1122",
			"name": "福建"
		}, {
			"value": "9023",
			"name": "安徽"
		}, {
			"value": "5581",
			"name": "江西"
		}, {
			"value": "15583",
			"name": "湖北"
		}, {
			"value": "8153",
			"name": "湖南"
		}, {
			"value": "11852",
			"name": "广东"
		}, {
			"value": "1414",
			"name": "广西"
		}, {
			"value": "697",
			"name": "贵州"
		}, {
			"value": "1307",
			"name": "云南"
		}, {
			"value": "159",
			"name": "海南"
		}, {
			"value": "1066",
			"name": "黑龙江"
		}, {
			"value": "2320",
			"name": "吉林"
		}, {
			"value": "12050",
			"name": "辽宁"
		}, {
			"value": "6471",
			"name": "陕西"
		}, {
			"value": "3248",
			"name": "新疆"
		}, {
			"value": "23340",
			"name": "内蒙古"
		}, {
			"value": "1312",
			"name": "青海"
		}, {
			"value": "1912",
			"name": "宁夏"
		}, {
			"value": "566",
			"name": "甘肃"
		}, {
			"value": "7",
			"name": "西藏"
		}, {
			"value": "1789",
			"name": "四川"
		}, {
			"value": "1721",
			"name": "重庆"
		}],
		"nameName": "天津",
		"toatl": "404838"
	}, {
		"item": [{
			"value": "74719",
			"name": "北京"
		}, {
			"value": "280829",
			"name": "天津"
		}, {
			"value": "-1",
			"name": "河北"
		}, {
			"value": "560773",
			"name": "山西"
		}, {
			"value": "467653",
			"name": "河南"
		}, {
			"value": "944794",
			"name": "山东"
		}, {
			"value": "10111",
			"name": "上海"
		}, {
			"value": "296894",
			"name": "江苏"
		}, {
			"value": "74757",
			"name": "浙江"
		}, {
			"value": "14687",
			"name": "福建"
		}, {
			"value": "120358",
			"name": "安徽"
		}, {
			"value": "66477",
			"name": "江西"
		}, {
			"value": "182358",
			"name": "湖北"
		}, {
			"value": "185446",
			"name": "湖南"
		}, {
			"value": "104520",
			"name": "广东"
		}, {
			"value": "45482",
			"name": "广西"
		}, {
			"value": "22685",
			"name": "贵州"
		}, {
			"value": "54968",
			"name": "云南"
		}, {
			"value": "5076",
			"name": "海南"
		}, {
			"value": "10425",
			"name": "黑龙江"
		}, {
			"value": "12829",
			"name": "吉林"
		}, {
			"value": "56819",
			"name": "辽宁"
		}, {
			"value": "124908",
			"name": "陕西"
		}, {
			"value": "65438",
			"name": "新疆"
		}, {
			"value": "154181",
			"name": "内蒙古"
		}, {
			"value": "57555",
			"name": "青海"
		}, {
			"value": "44429",
			"name": "宁夏"
		}, {
			"value": "15347",
			"name": "甘肃"
		}, {
			"value": "210",
			"name": "西藏"
		}, {
			"value": "32237",
			"name": "四川"
		}, {
			"value": "17454",
			"name": "重庆"
		}],
		"nameName": "河北",
		"toatl": "4104419"
	}, {
		"item": [{
			"value": "5569",
			"name": "北京"
		}, {
			"value": "26523",
			"name": "天津"
		}, {
			"value": "270170",
			"name": "河北"
		}, {
			"value": "-1",
			"name": "山西"
		}, {
			"value": "174404",
			"name": "河南"
		}, {
			"value": "82322",
			"name": "山东"
		}, {
			"value": "1302",
			"name": "上海"
		}, {
			"value": "26353",
			"name": "江苏"
		}, {
			"value": "12429",
			"name": "浙江"
		}, {
			"value": "4348",
			"name": "福建"
		}, {
			"value": "30930",
			"name": "安徽"
		}, {
			"value": "13353",
			"name": "江西"
		}, {
			"value": "49385",
			"name": "湖北"
		}, {
			"value": "47814",
			"name": "湖南"
		}, {
			"value": "35812",
			"name": "广东"
		}, {
			"value": "29325",
			"name": "广西"
		}, {
			"value": "17175",
			"name": "贵州"
		}, {
			"value": "26601",
			"name": "云南"
		}, {
			"value": "1857",
			"name": "海南"
		}, {
			"value": "1204",
			"name": "黑龙江"
		}, {
			"value": "971",
			"name": "吉林"
		}, {
			"value": "2939",
			"name": "辽宁"
		}, {
			"value": "184292",
			"name": "陕西"
		}, {
			"value": "14601",
			"name": "新疆"
		}, {
			"value": "71240",
			"name": "内蒙古"
		}, {
			"value": "13396",
			"name": "青海"
		}, {
			"value": "11547",
			"name": "宁夏"
		}, {
			"value": "4042",
			"name": "甘肃"
		}, {
			"value": "99",
			"name": "西藏"
		}, {
			"value": "21876",
			"name": "四川"
		}, {
			"value": "20596",
			"name": "重庆"
		}],
		"nameName": "山西",
		"toatl": "1202475"
	}, {
		"item": [{
			"value": "6497",
			"name": "北京"
		}, {
			"value": "21655",
			"name": "天津"
		}, {
			"value": "173863",
			"name": "河北"
		}, {
			"value": "243511",
			"name": "山西"
		}, {
			"value": "-1",
			"name": "河南"
		}, {
			"value": "291629",
			"name": "山东"
		}, {
			"value": "34135",
			"name": "上海"
		}, {
			"value": "161958",
			"name": "江苏"
		}, {
			"value": "258534",
			"name": "浙江"
		}, {
			"value": "45117",
			"name": "福建"
		}, {
			"value": "384375",
			"name": "安徽"
		}, {
			"value": "155058",
			"name": "江西"
		}, {
			"value": "465180",
			"name": "湖北"
		}, {
			"value": "371371",
			"name": "湖南"
		}, {
			"value": "338346",
			"name": "广东"
		}, {
			"value": "109397",
			"name": "广西"
		}, {
			"value": "38711",
			"name": "贵州"
		}, {
			"value": "101152",
			"name": "云南"
		}, {
			"value": "15677",
			"name": "海南"
		}, {
			"value": "1549",
			"name": "黑龙江"
		}, {
			"value": "1583",
			"name": "吉林"
		}, {
			"value": "7638",
			"name": "辽宁"
		}, {
			"value": "199118",
			"name": "陕西"
		}, {
			"value": "58989",
			"name": "新疆"
		}, {
			"value": "16890",
			"name": "内蒙古"
		}, {
			"value": "54089",
			"name": "青海"
		}, {
			"value": "37989",
			"name": "宁夏"
		}, {
			"value": "16627",
			"name": "甘肃"
		}, {
			"value": "551",
			"name": "西藏"
		}, {
			"value": "44146",
			"name": "四川"
		}, {
			"value": "47773",
			"name": "重庆"
		}],
		"nameName": "河南",
		"toatl": "3703108"
	}, {
		"item": [{
			"value": "10258",
			"name": "北京"
		}, {
			"value": "47950",
			"name": "天津"
		}, {
			"value": "360850",
			"name": "河北"
		}, {
			"value": "129137",
			"name": "山西"
		}, {
			"value": "408589",
			"name": "河南"
		}, {
			"value": "-1",
			"name": "山东"
		}, {
			"value": "30329",
			"name": "上海"
		}, {
			"value": "584109",
			"name": "江苏"
		}, {
			"value": "189836",
			"name": "浙江"
		}, {
			"value": "24864",
			"name": "福建"
		}, {
			"value": "269675",
			"name": "安徽"
		}, {
			"value": "152862",
			"name": "江西"
		}, {
			"value": "154188",
			"name": "湖北"
		}, {
			"value": "154283",
			"name": "湖南"
		}, {
			"value": "138192",
			"name": "广东"
		}, {
			"value": "68700",
			"name": "广西"
		}, {
			"value": "23375",
			"name": "贵州"
		}, {
			"value": "63256",
			"name": "云南"
		}, {
			"value": "9409",
			"name": "海南"
		}, {
			"value": "5310",
			"name": "黑龙江"
		}, {
			"value": "8330",
			"name": "吉林"
		}, {
			"value": "28866",
			"name": "辽宁"
		}, {
			"value": "90472",
			"name": "陕西"
		}, {
			"value": "44876",
			"name": "新疆"
		}, {
			"value": "26703",
			"name": "内蒙古"
		}, {
			"value": "42709",
			"name": "青海"
		}, {
			"value": "20392",
			"name": "宁夏"
		}, {
			"value": "7555",
			"name": "甘肃"
		}, {
			"value": "180",
			"name": "西藏"
		}, {
			"value": "29846",
			"name": "四川"
		}, {
			"value": "22245",
			"name": "重庆"
		}],
		"nameName": "山东",
		"toatl": "3147346"
	}, {
		"item": [{
			"value": "3920",
			"name": "北京"
		}, {
			"value": "23267",
			"name": "天津"
		}, {
			"value": "33218",
			"name": "河北"
		}, {
			"value": "8692",
			"name": "山西"
		}, {
			"value": "74830",
			"name": "河南"
		}, {
			"value": "96611",
			"name": "山东"
		}, {
			"value": "-1",
			"name": "上海"
		}, {
			"value": "424309",
			"name": "江苏"
		}, {
			"value": "450667",
			"name": "浙江"
		}, {
			"value": "19657",
			"name": "福建"
		}, {
			"value": "172763",
			"name": "安徽"
		}, {
			"value": "93840",
			"name": "江西"
		}, {
			"value": "103004",
			"name": "湖北"
		}, {
			"value": "45837",
			"name": "湖南"
		}, {
			"value": "86226",
			"name": "广东"
		}, {
			"value": "13227",
			"name": "广西"
		}, {
			"value": "8181",
			"name": "贵州"
		}, {
			"value": "8470",
			"name": "云南"
		}, {
			"value": "812",
			"name": "海南"
		}, {
			"value": "3146",
			"name": "黑龙江"
		}, {
			"value": "5152",
			"name": "吉林"
		}, {
			"value": "18829",
			"name": "辽宁"
		}, {
			"value": "18029",
			"name": "陕西"
		}, {
			"value": "1532",
			"name": "新疆"
		}, {
			"value": "2148",
			"name": "内蒙古"
		}, {
			"value": "687",
			"name": "青海"
		}, {
			"value": "635",
			"name": "宁夏"
		}, {
			"value": "843",
			"name": "甘肃"
		}, {
			"value": "2",
			"name": "西藏"
		}, {
			"value": "13454",
			"name": "四川"
		}, {
			"value": "21579",
			"name": "重庆"
		}],
		"nameName": "上海",
		"toatl": "1753567"
	}, {
		"item": [{
			"value": "3402",
			"name": "北京"
		}, {
			"value": "23282",
			"name": "天津"
		}, {
			"value": "77095",
			"name": "河北"
		}, {
			"value": "20991",
			"name": "山西"
		}, {
			"value": "164719",
			"name": "河南"
		}, {
			"value": "399801",
			"name": "山东"
		}, {
			"value": "93453",
			"name": "上海"
		}, {
			"value": "-1",
			"name": "江苏"
		}, {
			"value": "383471",
			"name": "浙江"
		}, {
			"value": "21798",
			"name": "福建"
		}, {
			"value": "435410",
			"name": "安徽"
		}, {
			"value": "185077",
			"name": "江西"
		}, {
			"value": "148856",
			"name": "湖北"
		}, {
			"value": "95408",
			"name": "湖南"
		}, {
			"value": "112019",
			"name": "广东"
		}, {
			"value": "32456",
			"name": "广西"
		}, {
			"value": "16241",
			"name": "贵州"
		}, {
			"value": "27855",
			"name": "云南"
		}, {
			"value": "3467",
			"name": "海南"
		}, {
			"value": "1626",
			"name": "黑龙江"
		}, {
			"value": "2172",
			"name": "吉林"
		}, {
			"value": "10876",
			"name": "辽宁"
		}, {
			"value": "33555",
			"name": "陕西"
		}, {
			"value": "7551",
			"name": "新疆"
		}, {
			"value": "8106",
			"name": "内蒙古"
		}, {
			"value": "9688",
			"name": "青海"
		}, {
			"value": "7297",
			"name": "宁夏"
		}, {
			"value": "4826",
			"name": "甘肃"
		}, {
			"value": "70",
			"name": "西藏"
		}, {
			"value": "13585",
			"name": "四川"
		}, {
			"value": "19124",
			"name": "重庆"
		}],
		"nameName": "江苏",
		"toatl": "2363277"
	}, {
		"item": [{
			"value": "1184",
			"name": "北京"
		}, {
			"value": "8350",
			"name": "天津"
		}, {
			"value": "24030",
			"name": "河北"
		}, {
			"value": "5426",
			"name": "山西"
		}, {
			"value": "39115",
			"name": "河南"
		}, {
			"value": "51577",
			"name": "山东"
		}, {
			"value": "42845",
			"name": "上海"
		}, {
			"value": "89480",
			"name": "江苏"
		}, {
			"value": "-1",
			"name": "浙江"
		}, {
			"value": "24404",
			"name": "福建"
		}, {
			"value": "75924",
			"name": "安徽"
		}, {
			"value": "114986",
			"name": "江西"
		}, {
			"value": "55144",
			"name": "湖北"
		}, {
			"value": "41548",
			"name": "湖南"
		}, {
			"value": "69645",
			"name": "广东"
		}, {
			"value": "15232",
			"name": "广西"
		}, {
			"value": "8226",
			"name": "贵州"
		}, {
			"value": "9554",
			"name": "云南"
		}, {
			"value": "703",
			"name": "海南"
		}, {
			"value": "2212",
			"name": "黑龙江"
		}, {
			"value": "2265",
			"name": "吉林"
		}, {
			"value": "10035",
			"name": "辽宁"
		}, {
			"value": "10002",
			"name": "陕西"
		}, {
			"value": "908",
			"name": "新疆"
		}, {
			"value": "869",
			"name": "内蒙古"
		}, {
			"value": "747",
			"name": "青海"
		}, {
			"value": "635",
			"name": "宁夏"
		}, {
			"value": "680",
			"name": "甘肃"
		}, {
			"value": "6",
			"name": "西藏"
		}, {
			"value": "7904",
			"name": "四川"
		}, {
			"value": "13727",
			"name": "重庆"
		}],
		"nameName": "浙江",
		"toatl": "727363"
	}, {
		"item": [{
			"value": "198",
			"name": "北京"
		}, {
			"value": "1315",
			"name": "天津"
		}, {
			"value": "3295",
			"name": "河北"
		}, {
			"value": "568",
			"name": "山西"
		}, {
			"value": "3101",
			"name": "河南"
		}, {
			"value": "7400",
			"name": "山东"
		}, {
			"value": "1757",
			"name": "上海"
		}, {
			"value": "7143",
			"name": "江苏"
		}, {
			"value": "40116",
			"name": "浙江"
		}, {
			"value": "-1",
			"name": "福建"
		}, {
			"value": "6618",
			"name": "安徽"
		}, {
			"value": "13065",
			"name": "江西"
		}, {
			"value": "8315",
			"name": "湖北"
		}, {
			"value": "7402",
			"name": "湖南"
		}, {
			"value": "40680",
			"name": "广东"
		}, {
			"value": "2599",
			"name": "广西"
		}, {
			"value": "1280",
			"name": "贵州"
		}, {
			"value": "1435",
			"name": "云南"
		}, {
			"value": "102",
			"name": "海南"
		}, {
			"value": "44",
			"name": "黑龙江"
		}, {
			"value": "89",
			"name": "吉林"
		}, {
			"value": "430",
			"name": "辽宁"
		}, {
			"value": "596",
			"name": "陕西"
		}, {
			"value": "142",
			"name": "新疆"
		}, {
			"value": "111",
			"name": "内蒙古"
		}, {
			"value": "50",
			"name": "青海"
		}, {
			"value": "24",
			"name": "宁夏"
		}, {
			"value": "46",
			"name": "甘肃"
		}, {
			"value": "0",
			"name": "西藏"
		}, {
			"value": "512",
			"name": "四川"
		}, {
			"value": "3135",
			"name": "重庆"
		}],
		"nameName": "福建",
		"toatl": "151568"
	}, {
		"item": [{
			"value": "2869",
			"name": "北京"
		}, {
			"value": "14440",
			"name": "天津"
		}, {
			"value": "59698",
			"name": "河北"
		}, {
			"value": "18629",
			"name": "山西"
		}, {
			"value": "326476",
			"name": "河南"
		}, {
			"value": "138851",
			"name": "山东"
		}, {
			"value": "61685",
			"name": "上海"
		}, {
			"value": "490095",
			"name": "江苏"
		}, {
			"value": "762596",
			"name": "浙江"
		}, {
			"value": "44314",
			"name": "福建"
		}, {
			"value": "-1",
			"name": "安徽"
		}, {
			"value": "406604",
			"name": "江西"
		}, {
			"value": "244150",
			"name": "湖北"
		}, {
			"value": "163238",
			"name": "湖南"
		}, {
			"value": "369177",
			"name": "广东"
		}, {
			"value": "61178",
			"name": "广西"
		}, {
			"value": "23236",
			"name": "贵州"
		}, {
			"value": "49320",
			"name": "云南"
		}, {
			"value": "9600",
			"name": "海南"
		}, {
			"value": "1221",
			"name": "黑龙江"
		}, {
			"value": "1446",
			"name": "吉林"
		}, {
			"value": "6352",
			"name": "辽宁"
		}, {
			"value": "68329",
			"name": "陕西"
		}, {
			"value": "12961",
			"name": "新疆"
		}, {
			"value": "5654",
			"name": "内蒙古"
		}, {
			"value": "15481",
			"name": "青海"
		}, {
			"value": "8131",
			"name": "宁夏"
		}, {
			"value": "7217",
			"name": "甘肃"
		}, {
			"value": "90",
			"name": "西藏"
		}, {
			"value": "21864",
			"name": "四川"
		}, {
			"value": "38391",
			"name": "重庆"
		}],
		"nameName": "安徽",
		"toatl": "3433293"
	}, {
		"item": [{
			"value": "1192",
			"name": "北京"
		}, {
			"value": "4695",
			"name": "天津"
		}, {
			"value": "13643",
			"name": "河北"
		}, {
			"value": "3001",
			"name": "山西"
		}, {
			"value": "33436",
			"name": "河南"
		}, {
			"value": "20138",
			"name": "山东"
		}, {
			"value": "8833",
			"name": "上海"
		}, {
			"value": "36039",
			"name": "江苏"
		}, {
			"value": "237263",
			"name": "浙江"
		}, {
			"value": "53049",
			"name": "福建"
		}, {
			"value": "61860",
			"name": "安徽"
		}, {
			"value": "-1",
			"name": "江西"
		}, {
			"value": "94840",
			"name": "湖北"
		}, {
			"value": "260143",
			"name": "湖南"
		}, {
			"value": "578583",
			"name": "广东"
		}, {
			"value": "82802",
			"name": "广西"
		}, {
			"value": "53137",
			"name": "贵州"
		}, {
			"value": "49854",
			"name": "云南"
		}, {
			"value": "32944",
			"name": "海南"
		}, {
			"value": "881",
			"name": "黑龙江"
		}, {
			"value": "1081",
			"name": "吉林"
		}, {
			"value": "2299",
			"name": "辽宁"
		}, {
			"value": "11689",
			"name": "陕西"
		}, {
			"value": "2599",
			"name": "新疆"
		}, {
			"value": "2171",
			"name": "内蒙古"
		}, {
			"value": "8749",
			"name": "青海"
		}, {
			"value": "1929",
			"name": "宁夏"
		}, {
			"value": "2913",
			"name": "甘肃"
		}, {
			"value": "87",
			"name": "西藏"
		}, {
			"value": "8009",
			"name": "四川"
		}, {
			"value": "22639",
			"name": "重庆"
		}],
		"nameName": "江西",
		"toatl": "1690498"
	}, {
		"item": [{
			"value": "618",
			"name": "北京"
		}, {
			"value": "3410",
			"name": "天津"
		}, {
			"value": "18412",
			"name": "河北"
		}, {
			"value": "4853",
			"name": "山西"
		}, {
			"value": "89730",
			"name": "河南"
		}, {
			"value": "20717",
			"name": "山东"
		}, {
			"value": "3735",
			"name": "上海"
		}, {
			"value": "21872",
			"name": "江苏"
		}, {
			"value": "45158",
			"name": "浙江"
		}, {
			"value": "16987",
			"name": "福建"
		}, {
			"value": "56650",
			"name": "安徽"
		}, {
			"value": "68047",
			"name": "江西"
		}, {
			"value": "-1",
			"name": "湖北"
		}, {
			"value": "259909",
			"name": "湖南"
		}, {
			"value": "207239",
			"name": "广东"
		}, {
			"value": "32446",
			"name": "广西"
		}, {
			"value": "14896",
			"name": "贵州"
		}, {
			"value": "19304",
			"name": "云南"
		}, {
			"value": "3523",
			"name": "海南"
		}, {
			"value": "311",
			"name": "黑龙江"
		}, {
			"value": "522",
			"name": "吉林"
		}, {
			"value": "1947",
			"name": "辽宁"
		}, {
			"value": "42278",
			"name": "陕西"
		}, {
			"value": "3929",
			"name": "新疆"
		}, {
			"value": "1457",
			"name": "内蒙古"
		}, {
			"value": "4124",
			"name": "青海"
		}, {
			"value": "5149",
			"name": "宁夏"
		}, {
			"value": "2389",
			"name": "甘肃"
		}, {
			"value": "101",
			"name": "西藏"
		}, {
			"value": "14103",
			"name": "四川"
		}, {
			"value": "27293",
			"name": "重庆"
		}],
		"nameName": "湖北",
		"toatl": "991109"
	}, {
		"item": [{
			"value": "176",
			"name": "北京"
		}, {
			"value": "2170",
			"name": "天津"
		}, {
			"value": "5685",
			"name": "河北"
		}, {
			"value": "1575",
			"name": "山西"
		}, {
			"value": "11162",
			"name": "河南"
		}, {
			"value": "4690",
			"name": "山东"
		}, {
			"value": "832",
			"name": "上海"
		}, {
			"value": "3737",
			"name": "江苏"
		}, {
			"value": "13116",
			"name": "浙江"
		}, {
			"value": "2454",
			"name": "福建"
		}, {
			"value": "6766",
			"name": "安徽"
		}, {
			"value": "32783",
			"name": "江西"
		}, {
			"value": "39877",
			"name": "湖北"
		}, {
			"value": "-1",
			"name": "湖南"
		}, {
			"value": "227650",
			"name": "广东"
		}, {
			"value": "38369",
			"name": "广西"
		}, {
			"value": "28141",
			"name": "贵州"
		}, {
			"value": "10385",
			"name": "云南"
		}, {
			"value": "2781",
			"name": "海南"
		}, {
			"value": "498",
			"name": "黑龙江"
		}, {
			"value": "1472",
			"name": "吉林"
		}, {
			"value": "2758",
			"name": "辽宁"
		}, {
			"value": "2209",
			"name": "陕西"
		}, {
			"value": "367",
			"name": "新疆"
		}, {
			"value": "295",
			"name": "内蒙古"
		}, {
			"value": "209",
			"name": "青海"
		}, {
			"value": "277",
			"name": "宁夏"
		}, {
			"value": "300",
			"name": "甘肃"
		}, {
			"value": "6",
			"name": "西藏"
		}, {
			"value": "1499",
			"name": "四川"
		}, {
			"value": "11925",
			"name": "重庆"
		}],
		"nameName": "湖南",
		"toatl": "454164"
	}, {
		"item": [{
			"value": "1077",
			"name": "北京"
		}, {
			"value": "3647",
			"name": "天津"
		}, {
			"value": "16499",
			"name": "河北"
		}, {
			"value": "3434",
			"name": "山西"
		}, {
			"value": "30752",
			"name": "河南"
		}, {
			"value": "12269",
			"name": "山东"
		}, {
			"value": "4315",
			"name": "上海"
		}, {
			"value": "17298",
			"name": "江苏"
		}, {
			"value": "60422",
			"name": "浙江"
		}, {
			"value": "13485",
			"name": "福建"
		}, {
			"value": "22315",
			"name": "安徽"
		}, {
			"value": "83444",
			"name": "江西"
		}, {
			"value": "48276",
			"name": "湖北"
		}, {
			"value": "131875",
			"name": "湖南"
		}, {
			"value": "-1",
			"name": "广东"
		}, {
			"value": "102786",
			"name": "广西"
		}, {
			"value": "11918",
			"name": "贵州"
		}, {
			"value": "16306",
			"name": "云南"
		}, {
			"value": "8294",
			"name": "海南"
		}, {
			"value": "349",
			"name": "黑龙江"
		}, {
			"value": "447",
			"name": "吉林"
		}, {
			"value": "2538",
			"name": "辽宁"
		}, {
			"value": "7403",
			"name": "陕西"
		}, {
			"value": "865",
			"name": "新疆"
		}, {
			"value": "289",
			"name": "内蒙古"
		}, {
			"value": "335",
			"name": "青海"
		}, {
			"value": "508",
			"name": "宁夏"
		}, {
			"value": "465",
			"name": "甘肃"
		}, {
			"value": "6",
			"name": "西藏"
		}, {
			"value": "6964",
			"name": "四川"
		}, {
			"value": "45685",
			"name": "重庆"
		}],
		"nameName": "广东",
		"toatl": "654266"
	}, {
		"item": [{
			"value": "245",
			"name": "北京"
		}, {
			"value": "632",
			"name": "天津"
		}, {
			"value": "3674",
			"name": "河北"
		}, {
			"value": "489",
			"name": "山西"
		}, {
			"value": "10988",
			"name": "河南"
		}, {
			"value": "10442",
			"name": "山东"
		}, {
			"value": "439",
			"name": "上海"
		}, {
			"value": "4272",
			"name": "江苏"
		}, {
			"value": "9801",
			"name": "浙江"
		}, {
			"value": "3814",
			"name": "福建"
		}, {
			"value": "3669",
			"name": "安徽"
		}, {
			"value": "9288",
			"name": "江西"
		}, {
			"value": "19514",
			"name": "湖北"
		}, {
			"value": "46640",
			"name": "湖南"
		}, {
			"value": "422037",
			"name": "广东"
		}, {
			"value": "-1",
			"name": "广西"
		}, {
			"value": "37001",
			"name": "贵州"
		}, {
			"value": "72439",
			"name": "云南"
		}, {
			"value": "13242",
			"name": "海南"
		}, {
			"value": "35",
			"name": "黑龙江"
		}, {
			"value": "32",
			"name": "吉林"
		}, {
			"value": "115",
			"name": "辽宁"
		}, {
			"value": "3885",
			"name": "陕西"
		}, {
			"value": "212",
			"name": "新疆"
		}, {
			"value": "50",
			"name": "内蒙古"
		}, {
			"value": "98",
			"name": "青海"
		}, {
			"value": "16",
			"name": "宁夏"
		}, {
			"value": "67",
			"name": "甘肃"
		}, {
			"value": "2",
			"name": "西藏"
		}, {
			"value": "2090",
			"name": "四川"
		}, {
			"value": "3519",
			"name": "重庆"
		}],
		"nameName": "广西",
		"toatl": "678747"
	}, {
		"item": [{
			"value": "63",
			"name": "北京"
		}, {
			"value": "52",
			"name": "天津"
		}, {
			"value": "550",
			"name": "河北"
		}, {
			"value": "104",
			"name": "山西"
		}, {
			"value": "1502",
			"name": "河南"
		}, {
			"value": "421",
			"name": "山东"
		}, {
			"value": "64",
			"name": "上海"
		}, {
			"value": "199",
			"name": "江苏"
		}, {
			"value": "875",
			"name": "浙江"
		}, {
			"value": "155",
			"name": "福建"
		}, {
			"value": "297",
			"name": "安徽"
		}, {
			"value": "899",
			"name": "江西"
		}, {
			"value": "1510",
			"name": "湖北"
		}, {
			"value": "8298",
			"name": "湖南"
		}, {
			"value": "3958",
			"name": "广东"
		}, {
			"value": "14544",
			"name": "广西"
		}, {
			"value": "-1",
			"name": "贵州"
		}, {
			"value": "12109",
			"name": "云南"
		}, {
			"value": "52",
			"name": "海南"
		}, {
			"value": "16",
			"name": "黑龙江"
		}, {
			"value": "14",
			"name": "吉林"
		}, {
			"value": "62",
			"name": "辽宁"
		}, {
			"value": "155",
			"name": "陕西"
		}, {
			"value": "30",
			"name": "新疆"
		}, {
			"value": "17",
			"name": "内蒙古"
		}, {
			"value": "30",
			"name": "青海"
		}, {
			"value": "3",
			"name": "宁夏"
		}, {
			"value": "50",
			"name": "甘肃"
		}, {
			"value": "4",
			"name": "西藏"
		}, {
			"value": "957",
			"name": "四川"
		}, {
			"value": "1732",
			"name": "重庆"
		}],
		"nameName": "贵州",
		"toatl": "48722"
	}, {
		"item": [{
			"value": "49",
			"name": "北京"
		}, {
			"value": "678",
			"name": "天津"
		}, {
			"value": "2012",
			"name": "河北"
		}, {
			"value": "677",
			"name": "山西"
		}, {
			"value": "4445",
			"name": "河南"
		}, {
			"value": "703",
			"name": "山东"
		}, {
			"value": "59",
			"name": "上海"
		}, {
			"value": "494",
			"name": "江苏"
		}, {
			"value": "899",
			"name": "浙江"
		}, {
			"value": "247",
			"name": "福建"
		}, {
			"value": "976",
			"name": "安徽"
		}, {
			"value": "1335",
			"name": "江西"
		}, {
			"value": "1935",
			"name": "湖北"
		}, {
			"value": "4256",
			"name": "湖南"
		}, {
			"value": "5424",
			"name": "广东"
		}, {
			"value": "18401",
			"name": "广西"
		}, {
			"value": "28494",
			"name": "贵州"
		}, {
			"value": "-1",
			"name": "云南"
		}, {
			"value": "137",
			"name": "海南"
		}, {
			"value": "188",
			"name": "黑龙江"
		}, {
			"value": "171",
			"name": "吉林"
		}, {
			"value": "613",
			"name": "辽宁"
		}, {
			"value": "1461",
			"name": "陕西"
		}, {
			"value": "131",
			"name": "新疆"
		}, {
			"value": "151",
			"name": "内蒙古"
		}, {
			"value": "229",
			"name": "青海"
		}, {
			"value": "31",
			"name": "宁夏"
		}, {
			"value": "296",
			"name": "甘肃"
		}, {
			"value": "64",
			"name": "西藏"
		}, {
			"value": "6783",
			"name": "四川"
		}, {
			"value": "1280",
			"name": "重庆"
		}],
		"nameName": "云南",
		"toatl": "82619"
	}, {
		"item": [{
			"value": "2",
			"name": "北京"
		}, {
			"value": "9",
			"name": "天津"
		}, {
			"value": "16",
			"name": "河北"
		}, {
			"value": "4",
			"name": "山西"
		}, {
			"value": "65",
			"name": "河南"
		}, {
			"value": "89",
			"name": "山东"
		}, {
			"value": "58",
			"name": "上海"
		}, {
			"value": "67",
			"name": "江苏"
		}, {
			"value": "268",
			"name": "浙江"
		}, {
			"value": "116",
			"name": "福建"
		}, {
			"value": "59",
			"name": "安徽"
		}, {
			"value": "214",
			"name": "江西"
		}, {
			"value": "126",
			"name": "湖北"
		}, {
			"value": "232",
			"name": "湖南"
		}, {
			"value": "15886",
			"name": "广东"
		}, {
			"value": "410",
			"name": "广西"
		}, {
			"value": "23",
			"name": "贵州"
		}, {
			"value": "4",
			"name": "云南"
		}, {
			"value": "-1",
			"name": "海南"
		}, {
			"value": "1",
			"name": "黑龙江"
		}, {
                "name": "吉林",
                "value":"0"
		}, {
			"value": "1",
			"name": "辽宁"
		}, {
			"value": "35",
			"name": "陕西"
		}, {
			"value": "6",
			"name": "新疆"
		}, {
			"value": "3",
			"name": "内蒙古"
		}, {
                "name": "青海",
                "value":"0"
		}, {
			"value": "2",
			"name": "宁夏"
		}, {
			"value": "7",
			"name": "甘肃"
		}, {
			"value": "0",
			"name": "西藏"
		}, {
			"value": "23",
			"name": "四川"
		}, {
			"value": "7",
			"name": "重庆"
		}],
		"nameName": "海南",
		"toatl": "17733"
	}, {
		"item": [{
			"value": "2954",
			"name": "北京"
		}, {
			"value": "22492",
			"name": "天津"
		}, {
			"value": "100067",
			"name": "河北"
		}, {
			"value": "15478",
			"name": "山西"
		}, {
			"value": "46941",
			"name": "河南"
		}, {
			"value": "113329",
			"name": "山东"
		}, {
			"value": "1465",
			"name": "上海"
		}, {
			"value": "39768",
			"name": "江苏"
		}, {
			"value": "12332",
			"name": "浙江"
		}, {
			"value": "1817",
			"name": "福建"
		}, {
			"value": "13334",
			"name": "安徽"
		}, {
			"value": "8539",
			"name": "江西"
		}, {
			"value": "19562",
			"name": "湖北"
		}, {
			"value": "18074",
			"name": "湖南"
		}, {
			"value": "14988",
			"name": "广东"
		}, {
			"value": "6924",
			"name": "广西"
		}, {
			"value": "2353",
			"name": "贵州"
		}, {
			"value": "7011",
			"name": "云南"
		}, {
			"value": "1551",
			"name": "海南"
		}, {
			"value": "-1",
			"name": "黑龙江"
		}, {
			"value": "136650",
			"name": "吉林"
		}, {
			"value": "148340",
			"name": "辽宁"
		}, {
			"value": "10472",
			"name": "陕西"
		}, {
			"value": "7845",
			"name": "新疆"
		}, {
			"value": "73693",
			"name": "内蒙古"
		}, {
			"value": "5348",
			"name": "青海"
		}, {
			"value": "1874",
			"name": "宁夏"
		}, {
			"value": "979",
			"name": "甘肃"
		}, {
			"value": "32",
			"name": "西藏"
		}, {
			"value": "2479",
			"name": "四川"
		}, {
			"value": "1982",
			"name": "重庆"
		}],
		"nameName": "黑龙江",
		"toatl": "838673"
	}, {
		"item": [{
			"value": "4061",
			"name": "北京"
		}, {
			"value": "25746",
			"name": "天津"
		}, {
			"value": "98161",
			"name": "河北"
		}, {
			"value": "10333",
			"name": "山西"
		}, {
			"value": "57888",
			"name": "河南"
		}, {
			"value": "86621",
			"name": "山东"
		}, {
			"value": "3981",
			"name": "上海"
		}, {
			"value": "44089",
			"name": "江苏"
		}, {
			"value": "17825",
			"name": "浙江"
		}, {
			"value": "3872",
			"name": "福建"
		}, {
			"value": "16386",
			"name": "安徽"
		}, {
			"value": "15711",
			"name": "江西"
		}, {
			"value": "31250",
			"name": "湖北"
		}, {
			"value": "24912",
			"name": "湖南"
		}, {
			"value": "27922",
			"name": "广东"
		}, {
			"value": "6860",
			"name": "广西"
		}, {
			"value": "2693",
			"name": "贵州"
		}, {
			"value": "6557",
			"name": "云南"
		}, {
			"value": "709",
			"name": "海南"
		}, {
			"value": "16256",
			"name": "黑龙江"
		}, {
			"value": "-1",
			"name": "吉林"
		}, {
			"value": "122640",
			"name": "辽宁"
		}, {
			"value": "22117",
			"name": "陕西"
		}, {
			"value": "5190",
			"name": "新疆"
		}, {
			"value": "40593",
			"name": "内蒙古"
		}, {
			"value": "3491",
			"name": "青海"
		}, {
			"value": "1482",
			"name": "宁夏"
		}, {
			"value": "926",
			"name": "甘肃"
		}, {
			"value": "22",
			"name": "西藏"
		}, {
			"value": "5533",
			"name": "四川"
		}, {
			"value": "6648",
			"name": "重庆"
		}],
		"nameName": "吉林",
		"toatl": "710475"
	}, {
		"item": [{
			"value": "7610",
			"name": "北京"
		}, {
			"value": "52241",
			"name": "天津"
		}, {
			"value": "279535",
			"name": "河北"
		}, {
			"value": "37356",
			"name": "山西"
		}, {
			"value": "105160",
			"name": "河南"
		}, {
			"value": "217415",
			"name": "山东"
		}, {
			"value": "5766",
			"name": "上海"
		}, {
			"value": "124974",
			"name": "江苏"
		}, {
			"value": "37554",
			"name": "浙江"
		}, {
			"value": "6613",
			"name": "福建"
		}, {
			"value": "28412",
			"name": "安徽"
		}, {
			"value": "21164",
			"name": "江西"
		}, {
			"value": "47323",
			"name": "湖北"
		}, {
			"value": "40580",
			"name": "湖南"
		}, {
			"value": "33137",
			"name": "广东"
		}, {
			"value": "14284",
			"name": "广西"
		}, {
			"value": "6805",
			"name": "贵州"
		}, {
			"value": "20432",
			"name": "云南"
		}, {
			"value": "2980",
			"name": "海南"
		}, {
			"value": "48188",
			"name": "黑龙江"
		}, {
			"value": "76973",
			"name": "吉林"
		}, {
			"value": "-1",
			"name": "辽宁"
		}, {
			"value": "23148",
			"name": "陕西"
		}, {
			"value": "12905",
			"name": "新疆"
		}, {
			"value": "90231",
			"name": "内蒙古"
		}, {
			"value": "5495",
			"name": "青海"
		}, {
			"value": "2764",
			"name": "宁夏"
		}, {
			"value": "2034",
			"name": "甘肃"
		}, {
			"value": "38",
			"name": "西藏"
		}, {
			"value": "7739",
			"name": "四川"
		}, {
			"value": "5574",
			"name": "重庆"
		}],
		"nameName": "辽宁",
		"toatl": "1364430"
	}, {
		"item": [{
			"value": "353",
			"name": "北京"
		}, {
			"value": "844",
			"name": "天津"
		}, {
			"value": "5072",
			"name": "河北"
		}, {
			"value": "47897",
			"name": "山西"
		}, {
			"value": "28332",
			"name": "河南"
		}, {
			"value": "4778",
			"name": "山东"
		}, {
			"value": "341",
			"name": "上海"
		}, {
			"value": "3883",
			"name": "江苏"
		}, {
			"value": "3065",
			"name": "浙江"
		}, {
			"value": "1643",
			"name": "福建"
		}, {
			"value": "7233",
			"name": "安徽"
		}, {
			"value": "4875",
			"name": "江西"
		}, {
			"value": "65209",
			"name": "湖北"
		}, {
			"value": "29493",
			"name": "湖南"
		}, {
			"value": "19299",
			"name": "广东"
		}, {
			"value": "6740",
			"name": "广西"
		}, {
			"value": "6106",
			"name": "贵州"
		}, {
			"value": "18720",
			"name": "云南"
		}, {
			"value": "1068",
			"name": "海南"
		}, {
			"value": "76",
			"name": "黑龙江"
		}, {
			"value": "99",
			"name": "吉林"
		}, {
			"value": "277",
			"name": "辽宁"
		}, {
			"value": "-1",
			"name": "陕西"
		}, {
			"value": "6222",
			"name": "新疆"
		}, {
			"value": "32530",
			"name": "内蒙古"
		}, {
			"value": "11671",
			"name": "青海"
		}, {
			"value": "23415",
			"name": "宁夏"
		}, {
			"value": "11815",
			"name": "甘肃"
		}, {
			"value": "110",
			"name": "西藏"
		}, {
			"value": "29745",
			"name": "四川"
		}, {
			"value": "12387",
			"name": "重庆"
		}],
		"nameName": "陕西",
		"toatl": "383298"
	}, {
		"item": [{
			"value": "49",
			"name": "北京"
		}, {
			"value": "42",
			"name": "天津"
		}, {
			"value": "249",
			"name": "河北"
		}, {
			"value": "155",
			"name": "山西"
		}, {
			"value": "601",
			"name": "河南"
		}, {
			"value": "181",
			"name": "山东"
		}, {
			"value": "10",
			"name": "上海"
		}, {
			"value": "168",
			"name": "江苏"
		}, {
			"value": "132",
			"name": "浙江"
		}, {
			"value": "52",
			"name": "福建"
		}, {
			"value": "291",
			"name": "安徽"
		}, {
			"value": "106",
			"name": "江西"
		}, {
			"value": "456",
			"name": "湖北"
		}, {
			"value": "460",
			"name": "湖南"
		}, {
			"value": "299",
			"name": "广东"
		}, {
			"value": "37",
			"name": "广西"
		}, {
			"value": "48",
			"name": "贵州"
		}, {
			"value": "52",
			"name": "云南"
		}, {
			"value": "1",
			"name": "海南"
		}, {
			"value": "7",
			"name": "黑龙江"
		}, {
			"value": "2",
			"name": "吉林"
		}, {
			"value": "11",
			"name": "辽宁"
		}, {
			"value": "655",
			"name": "陕西"
		}, {
			"value": "-1",
			"name": "新疆"
		}, {
			"value": "73",
			"name": "内蒙古"
		}, {
			"value": "1768",
			"name": "青海"
		}, {
			"value": "226",
			"name": "宁夏"
		}, {
			"value": "1583",
			"name": "甘肃"
		}, {
			"value": "4",
			"name": "西藏"
		}, {
			"value": "100",
			"name": "四川"
		}, {
			"value": "84",
			"name": "重庆"
		}],
		"nameName": "新疆",
		"toatl": "7902"
	}, {
		"item": [{
			"value": "5602",
			"name": "北京"
		}, {
			"value": "9866",
			"name": "天津"
		}, {
			"value": "73918",
			"name": "河北"
		}, {
			"value": "32141",
			"name": "山西"
		}, {
			"value": "10904",
			"name": "河南"
		}, {
			"value": "22307",
			"name": "山东"
		}, {
			"value": "477",
			"name": "上海"
		}, {
			"value": "8875",
			"name": "江苏"
		}, {
			"value": "2779",
			"name": "浙江"
		}, {
			"value": "393",
			"name": "福建"
		}, {
			"value": "2963",
			"name": "安徽"
		}, {
			"value": "1284",
			"name": "江西"
		}, {
			"value": "6199",
			"name": "湖北"
		}, {
			"value": "3621",
			"name": "湖南"
		}, {
			"value": "2672",
			"name": "广东"
		}, {
			"value": "942",
			"name": "广西"
		}, {
			"value": "421",
			"name": "贵州"
		}, {
			"value": "1817",
			"name": "云南"
		}, {
			"value": "77",
			"name": "海南"
		}, {
			"value": "4564",
			"name": "黑龙江"
		}, {
			"value": "2961",
			"name": "吉林"
		}, {
			"value": "17034",
			"name": "辽宁"
		}, {
			"value": "18197",
			"name": "陕西"
		}, {
			"value": "3234",
			"name": "新疆"
		}, {
			"value": "-1",
			"name": "内蒙古"
		}, {
			"value": "3529",
			"name": "青海"
		}, {
			"value": "9833",
			"name": "宁夏"
		}, {
			"value": "3038",
			"name": "甘肃"
		}, {
			"value": "20",
			"name": "西藏"
		}, {
			"value": "1946",
			"name": "四川"
		}, {
			"value": "1100",
			"name": "重庆"
		}],
		"nameName": "内蒙古",
		"toatl": "252714"
	}, {
		"item": [{
			"value": "6",
			"name": "北京"
		}, {
			"value": "5",
			"name": "天津"
		}, {
			"value": "64",
			"name": "河北"
		}, {
			"value": "196",
			"name": "山西"
		}, {
			"value": "463",
			"name": "河南"
		}, {
			"value": "102",
			"name": "山东"
		}, {
			"value": "5",
			"name": "上海"
		}, {
			"value": "56",
			"name": "江苏"
		}, {
			"value": "67",
			"name": "浙江"
		}, {
			"value": "7",
			"name": "福建"
		}, {
			"value": "221",
			"name": "安徽"
		}, {
			"value": "269",
			"name": "江西"
		}, {
			"value": "180",
			"name": "湖北"
		}, {
			"value": "96",
			"name": "湖南"
		}, {
			"value": "55",
			"name": "广东"
		}, {
			"value": "47",
			"name": "广西"
		}, {
			"value": "63",
			"name": "贵州"
		}, {
			"value": "460",
			"name": "云南"
		}, {
			"value": "30",
			"name": "海南"
		}, {
			"value": "2",
			"name": "黑龙江"
		}, {
			"value": "0",
			"name": "吉林"
		}, {
			"value": "4",
			"name": "辽宁"
		}, {
			"value": "545",
			"name": "陕西"
		}, {
			"value": "1003",
			"name": "新疆"
		}, {
			"value": "106",
			"name": "内蒙古"
		}, {
                "name": "青海",
            "value":"-1"
		}, {
			"value": "140",
			"name": "宁夏"
		}, {
			"value": "2209",
			"name": "甘肃"
		}, {
			"value": "211",
			"name": "西藏"
		}, {
			"value": "652",
			"name": "四川"
		}, {
			"value": "89",
			"name": "重庆"
		}],
		"nameName": "青海",
		"toatl": "7353"
	}, {
		"item": [{
			"value": "569",
			"name": "北京"
		}, {
			"value": "2136",
			"name": "天津"
		}, {
			"value": "5894",
			"name": "河北"
		}, {
			"value": "2929",
			"name": "山西"
		}, {
			"value": "37120",
			"name": "河南"
		}, {
			"value": "1424",
			"name": "山东"
		}, {
			"value": "270",
			"name": "上海"
		}, {
			"value": "5695",
			"name": "江苏"
		}, {
			"value": "7647",
			"name": "浙江"
		}, {
			"value": "1266",
			"name": "福建"
		}, {
			"value": "18601",
			"name": "安徽"
		}, {
			"value": "2698",
			"name": "江西"
		}, {
			"value": "28208",
			"name": "湖北"
		}, {
			"value": "14998",
			"name": "湖南"
		}, {
			"value": "14030",
			"name": "广东"
		}, {
			"value": "2291",
			"name": "广西"
		}, {
			"value": "1012",
			"name": "贵州"
		}, {
			"value": "7382",
			"name": "云南"
		}, {
			"value": "150",
			"name": "海南"
		}, {
			"value": "6",
			"name": "黑龙江"
		}, {
			"value": "5",
			"name": "吉林"
		}, {
			"value": "34",
			"name": "辽宁"
		}, {
			"value": "49622",
			"name": "陕西"
		}, {
			"value": "9321",
			"name": "新疆"
		}, {
			"value": "15006",
			"name": "内蒙古"
		}, {
			"value": "22159",
			"name": "青海"
		}, {
			"value": "-1",
			"name": "宁夏"
		}, {
			"value": "18891",
			"name": "甘肃"
		}, {
			"value": "63",
			"name": "西藏"
		}, {
			"value": "5885",
			"name": "四川"
		}, {
			"value": "2704",
			"name": "重庆"
		}],
		"nameName": "宁夏",
		"toatl": "278016"
	}, {
		"item": [{
			"value": "126",
			"name": "北京"
		}, {
			"value": "334",
			"name": "天津"
		}, {
			"value": "1741",
			"name": "河北"
		}, {
			"value": "1230",
			"name": "山西"
		}, {
			"value": "6385",
			"name": "河南"
		}, {
			"value": "611",
			"name": "山东"
		}, {
			"value": "73",
			"name": "上海"
		}, {
			"value": "968",
			"name": "江苏"
		}, {
			"value": "1052",
			"name": "浙江"
		}, {
			"value": "417",
			"name": "福建"
		}, {
			"value": "2723",
			"name": "安徽"
		}, {
			"value": "812",
			"name": "江西"
		}, {
			"value": "6429",
			"name": "湖北"
		}, {
			"value": "4429",
			"name": "湖南"
		}, {
			"value": "3535",
			"name": "广东"
		}, {
			"value": "677",
			"name": "广西"
		}, {
			"value": "710",
			"name": "贵州"
		}, {
			"value": "2445",
			"name": "云南"
		}, {
			"value": "44",
			"name": "海南"
		}, {
			"value": "9",
			"name": "黑龙江"
		}, {
			"value": "7",
			"name": "吉林"
		}, {
			"value": "27",
			"name": "辽宁"
		}, {
			"value": "18470",
			"name": "陕西"
		}, {
			"value": "6569",
			"name": "新疆"
		}, {
			"value": "2380",
			"name": "内蒙古"
		}, {
			"value": "16898",
			"name": "青海"
		}, {
			"value": "11275",
			"name": "宁夏"
		}, {
			"value": "-1",
			"name": "甘肃"
		}, {
			"value": "145",
			"name": "西藏"
		}, {
			"value": "3192",
			"name": "四川"
		}, {
			"value": "1328",
			"name": "重庆"
		}],
		"nameName": "甘肃",
		"toatl": "95041"
	}, {
		"item": [{
			"value": "0",
			"name": "北京"
		}, {
			"value": "0",
			"name": "天津"
		}, {
			"value": "1",
			"name": "河北"
		}, {
			"value": "0",
			"name": "山西"
		}, {
			"value": "1",
			"name": "河南"
		}, {
			"value": "0",
			"name": "山东"
		}, {
			"value": "0",
			"name": "上海"
		}, {
			"value": "0",
			"name": "江苏"
		}, {
			"value": "0",
			"name": "浙江"
		}, {
			"value": "0",
			"name": "福建"
		}, {
			"value": "0",
			"name": "安徽"
		}, {
			"value": "0",
			"name": "江西"
		}, {
			"value": "0",
			"name": "湖北"
		}, {
			"value": "0",
			"name": "湖南"
		}, {
			"value": "0",
			"name": "广东"
		}, {
			"value": "0",
			"name": "广西"
		}, {
			"value": "0",
			"name": "贵州"
		}, {
			"value": "28",
			"name": "云南"
		}, {
			"value": "0",
			"name": "海南"
		}, {
			"value": "0",
			"name": "黑龙江"
		}, {
			"value": "0",
			"name": "吉林"
		}, {
			"value": "0",
			"name": "辽宁"
		}, {
			"value": "0",
			"name": "陕西"
		}, {
			"value": "0",
			"name": "新疆"
		}, {
			"value": "0",
			"name": "内蒙古"
		}, {
			"value": "191",
			"name": "青海"
		}, {
			"value": "0",
			"name": "宁夏"
		}, {
			"value": "0",
			"name": "甘肃"
		}, {
			"value": "-1",
			"name": "西藏"
		}, {
			"value": "4",
			"name": "四川"
		}, {
			"value": "0",
			"name": "重庆"
		}],
		"nameName": "西藏",
		"toatl": "225"
	}, {
		"item": [{
			"value": "394",
			"name": "北京"
		}, {
			"value": "653",
			"name": "天津"
		}, {
			"value": "3137",
			"name": "河北"
		}, {
			"value": "1510",
			"name": "山西"
		}, {
			"value": "11056",
			"name": "河南"
		}, {
			"value": "2044",
			"name": "山东"
		}, {
			"value": "1013",
			"name": "上海"
		}, {
			"value": "3947",
			"name": "江苏"
		}, {
			"value": "5935",
			"name": "浙江"
		}, {
			"value": "2825",
			"name": "福建"
		}, {
			"value": "8015",
			"name": "安徽"
		}, {
			"value": "6657",
			"name": "江西"
		}, {
			"value": "24106",
			"name": "湖北"
		}, {
			"value": "38925",
			"name": "湖南"
		}, {
			"value": "41335",
			"name": "广东"
		}, {
			"value": "33421",
			"name": "广西"
		}, {
			"value": "53972",
			"name": "贵州"
		}, {
			"value": "134821",
			"name": "云南"
		}, {
			"value": "1391",
			"name": "海南"
		}, {
			"value": "123",
			"name": "黑龙江"
		}, {
			"value": "167",
			"name": "吉林"
		}, {
			"value": "374",
			"name": "辽宁"
		}, {
			"value": "19007",
			"name": "陕西"
		}, {
			"value": "3798",
			"name": "新疆"
		}, {
			"value": "506",
			"name": "内蒙古"
		}, {
			"value": "4199",
			"name": "青海"
		}, {
			"value": "929",
			"name": "宁夏"
		}, {
			"value": "1120",
			"name": "甘肃"
		}, {
			"value": "419",
			"name": "西藏"
		}, {
			"value": "-1",
			"name": "四川"
		}, {
			"value": "91128",
			"name": "重庆"
		}],
		"nameName": "四川",
		"toatl": "496927"
	}, {
		"item": [{
			"value": "617",
			"name": "北京"
		}, {
			"value": "2254",
			"name": "天津"
		}, {
			"value": "8839",
			"name": "河北"
		}, {
			"value": "1891",
			"name": "山西"
		}, {
			"value": "18995",
			"name": "河南"
		}, {
			"value": "8742",
			"name": "山东"
		}, {
			"value": "2374",
			"name": "上海"
		}, {
			"value": "11082",
			"name": "江苏"
		}, {
			"value": "19565",
			"name": "浙江"
		}, {
			"value": "7946",
			"name": "福建"
		}, {
			"value": "21038",
			"name": "安徽"
		}, {
			"value": "17393",
			"name": "江西"
		}, {
			"value": "96272",
			"name": "湖北"
		}, {
			"value": "126555",
			"name": "湖南"
		}, {
			"value": "65742",
			"name": "广东"
		}, {
			"value": "51330",
			"name": "广西"
		}, {
			"value": "270628",
			"name": "贵州"
		}, {
			"value": "100462",
			"name": "云南"
		}, {
			"value": "2595",
			"name": "海南"
		}, {
			"value": "159",
			"name": "黑龙江"
		}, {
			"value": "208",
			"name": "吉林"
		}, {
			"value": "793",
			"name": "辽宁"
		}, {
			"value": "10256",
			"name": "陕西"
		}, {
			"value": "5159",
			"name": "新疆"
		}, {
			"value": "327",
			"name": "内蒙古"
		}, {
			"value": "1728",
			"name": "青海"
		}, {
			"value": "297",
			"name": "宁夏"
		}, {
			"value": "1081",
			"name": "甘肃"
		}, {
			"value": "207",
			"name": "西藏"
		}, {
			"value": "82902",
			"name": "四川"
		}, {
			"value": "-1",
			"name": "重庆"
		}],
		"nameName": "重庆",
		"toatl": "937437"
	}]
}